export default __webpack_public_path__ + "static/blog5-0bcad668eb978aec2375881b1b3993a8.png";